import React, { useEffect, useState } from "react";
import { FaArrowUp } from "react-icons/fa";

export default function BackToTop() {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const container = document.getElementById('scroll-container');
    if (!container) return;

    const handleScroll = () => {
      setVisible(container.scrollTop > 600);
    };

    container.addEventListener('scroll', handleScroll);
    handleScroll();
    return () => container.removeEventListener('scroll', handleScroll);
  }, []);

  const scrollTop = () => {
    document.getElementById('scroll-container')?.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <button
      type="button"
      onClick={scrollTop}
      className={`back-to-top ${visible ? 'is-visible' : ''}`}
      aria-label="Back to top"
      title="Back to top"
    >
      <FaArrowUp aria-hidden="true" />
    </button>
  );
}
